
var app = angular.module('directives.cardPayBlock', []);

require('./directives/cardPayBlock.js');
require('./stylesheets/cardPayBlock.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardPayBlock/index.js
 ** module id = 141
 ** module chunks = 1
 **/